<template>
    <div class="table-container pull-auto">
        <div class="avue-crud">
            <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow" @search-change="searchChange">
            <template slot="search">
                <el-form-item label="名称">
                <el-input v-model="listQuery.name" clearable placeholder="请输入名称" size="small"/>
                </el-form-item>
            </template>
            <template  slot="menuLeft">
                <el-button v-if="sys_dict_add" style="margin-left: 10px;" size="mini" class="filter-item" @click="handleCreate" type="primary" icon="el-icon-plus">添加
                </el-button>
                <el-button v-if="sys_dict_edit" :disabled="totalStatus" size="mini" class="filter-item" type="primary" icon="el-icon-edit-outline" @click="handleUpdate">编辑
                </el-button>
                <el-button v-if="sys_dict_del" :disabled="totalStatus" size="mini" class="filter-item"  @click="handleDelete" type="primary" icon="el-icon-delete">删除
                </el-button>
                <el-button v-if="sys_dict_item" :disabled="totalStatus" size="mini" class="filter-item"  @click="handleItem" type="primary" icon="el-icon-notebook-1">字典项
                </el-button>
            </template>
            <template slot-scope="scope" slot="id">
                <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
            </template>
            </avue-crud>
            <!-- 添加 -->
            <edit ref="child" @refresh="refresh"></edit>
            <el-dialog
            title="字典项列表"
            :visible.sync="dialogVisible"
            ref="dictItem"
            width="50%">
            <avue-crud
            :data="itemData"
            :option="itemOption"
            ref="dictItem"
            @row-update="rowUpdate"
            @row-save="rowSave"
            @row-del="rowDel"
            @refresh-change="handleItem">
            </avue-crud>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { fetchList,delObj,getDictListById} from '@/api/admin/dict'
import {addObj,getObj,putObj} from '@/api/admin/dict'
import waves from '@/directive/waves/index.js' // 水波纹指令
import { mapGetters } from 'vuex'
import { objKeySort } from '@/util/ajaxsign'
import edit from './edit.vue'
export default {
    name: 'table_sys_dict',
     components: {edit},
    directives: {
        waves
    },
    data() {
        return {
            permissions : [],
            radio:'',
            itemData:[],
            list: [],
            total: 0,
            dialogVisible:false,
            listLoading: true,
            totalStatus : true,
            listQuery: {
                current: 1,
                size: 20,
                name :''
            },
            page: {
                pageSizes: [10, 20, 50, 100],
                currentPage: 1,
                total: 0,
                pageSize: 10
            },
             tableOption : {
                addBtn : false,
                refreshBtn : false,
                columnBtn : true,
                editBtn : true,
                delBtn : true,
                menu : false,
                page:true,
                border : true,
                align:'center',
                menuAlign:'center',
                height : window.innerHeight - 290,
                index:false,
                column:[
                {
                    label:'',
                    prop:'id',
                    width:40,
                    solt:true
                },
                {
                    label:'名称',
                    prop:'name'
                },
                 {
                    label:'编码',
                    prop:'code'
                },{
                    label:'备注',
                    prop:'tips'
                },{
                    label:'详情',
                    prop:'detail',
                    overHidden:true,
                }
                ]
            },
            itemOption: {
                addBtn : true,
                refreshBtn : false,
                columnBtn : false,
                editBtn : true,
                delBtn : true,
                menu : true,
                page:false,
                border : true,
                align:'center',
                menuAlign:'center',
                height : window.innerHeight - 310,
                column:[
                {
                    label:'',
                    prop:'id',
                    addVisdiplay:false,
                    hide:true,
                    visdiplay:false
                },
                {
                    label:'名称',
                    prop:'name',
                },
                 {
                    label:'编码',
                    prop:'code',
                    width:100,
                },
                {
                    label:'图标路径',
                    prop:'iconUrl',
                    overHidden:true,
                },{
                    label:'排序',
                    prop:'num',
                    width:100,
                }],
        
            // dialogFormVisible1: false,
            dialogStatus: '',
            sys_dict_add: false,
            sys_dict_upd: false,
            sys_dict_del: false,
            sys_dict_item: false,
            tableKey: 0
            }
        }
    },
    filters: {
        statusFilter(status) {
            const statusMap = {
                0: '有效',
                1: '无效'
            }
            return statusMap[status]
        }
    },
    created() {
        this.getList()
        this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
        for(var i=0;i<this.permissions.length;i++){
            if(this.permissions[i] == 'sys_dict_add'){
            this.sys_dict_add = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_dict_edit'){
            this.sys_dict_edit = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_dict_del'){
            this.sys_dict_del = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_dict_view'){
            this.sys_dict_item = this.permissions[i]
            }
        }

    },
    methods: {
        //刷新列表操作
        refresh(data){
            this.totalStatus=true;
            this.getList()
        },

        getSerialNumber(index) {
            return index + 1 + (this.listQuery.current - 1) * this.listQuery.size
        },
        showRow(row,event){
            this.radio = row.id;
            this.totalStatus=false;
        },
        getList() {
            this.listLoading = true
            this.listQuery.orderByField = 'create_time'
            this.listQuery.isAsc = false
            fetchList(objKeySort(this.listQuery)).then(response => {
                this.list = response.data.data
                this.page.total = response.data.data.length
                this.listLoading = false
            })
        },

        // 提交搜索
        onSubmit() {
            this.getList()
        },
        sizeChange(val) {
            this.listQuery.size = val
            this.getList()
        },
        currentChange(val) {
            this.listQuery.current = val
            this.getList()
        },
        searchChange(){
            this.getList()
        },
        //   删除
        handleDelete(row) {
            this.$confirm('此操作将永久删除该字典, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delObj(objKeySort({dictId:this.radio})).then(response => {
                    this.refresh()
                   this.$message({
                        type: 'info',
                        message: '删除成功'
                    });
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 添加弹窗
        handleCreate() {
            this.$refs.child.dialog('create',undefined);
        },

        //修改数据
        handleUpdate(){
            this.$refs.child.dialog('update',this.radio);
        },
        //查看和编辑字典项
        handleItem(){
            //获取字典项数据
            let id = this.radio;
            getDictListById(objKeySort({id:id})).then(response=>{
                this.itemData=[]
                if(response&&response.data&&response.data.data){
                    this.itemData = response.data.data;
                }
                if(!(this.dialogVisible))
                    this.dialogVisible = true
            });
        },
        rowUpdate(form,index,done,loading){
            var obj = {};
            obj.code = form.code;
            obj.id = form.id;
            obj.name=form.name;
            obj.iconUrl = form.iconUrl;
            obj.num = form.num,
            obj.pid = form.pid;
            obj.tips = form.tips;
            putObj(objKeySort(obj)).then(() => {
                this.$message({
                    title: '成功',
                    message: '修改成功',
                    type: 'success',
                    duration: 2000
                })
                done()
                this.handleItem();
                
            })    
        },
        rowSave(form,done,loading){
            form.pid = this.radio 
            addObj(objKeySort(form)).then(() => {
                this.$message({
                    title: '成功',
                    message: '创建成功',
                    type: 'success',
                    duration: 2000
                })
                this.handleItem();
                done()
            }) 
        },
        rowDel(form,index){
            this.$confirm('此操作将永久删除该字典, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delObj(objKeySort({dictId:form.id})).then(response => {
                   this.$message({
                        type: 'info',
                        message: '删除成功'
                    });
                    this.handleItem();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
    }
}
</script>
<style lang="scss" scoped>
  .filter-item1{
      width: auto;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      border: 0!important;
      margin-left: 0!important;
      margin-right: 22px;
  }
  .el_btn{
      clear:both;
  }
  .items{
      width: 30%;
      margin-right: 1%;
      display: inline-block;
      margin-top: 20px;
      margin-bottom: 0;
  }
  .items1>.el-form-item__content{
      margin-left: 0!important;
  }
  .items1s{
      width: 27%;
      margin-right: 1%;
      margin-bottom: 0;
      display: inline-block;
  }
</style>
